import PropTypes from "prop-types";
import 'layout/TopBanner/TopBanner.scss';
import Sort from "features/view/components/Sort/Sort";
import HTMLContainer from "components/ui/HTML/HTMLContainer";

function TopBanner({ title, intro, image, sortOptions, hideBottomActions, hasRoundedCorners, children }) {
  const bgImage = {
    backgroundImage: `url(${ image })`
  };

  return (
    <div className={ `background-primary ${ hasRoundedCorners ? 'top-banner-rounded' : '' }` }>
      <div className={ 'wrapper--fluid' }>
        <div className={ 'top-banner grid' }>
          <div className={ 'top-banner__left' }>
            <h1 className={ 'text-white' }>{ title }</h1>
            <HTMLContainer>
              { intro }
            </HTMLContainer>
          </div>

          <div className={ `top-banner__right ${ hasRoundedCorners ? 'top-banner__right--rounded' : '' }` }
               style={ bgImage }>
            <div className={ 'top-banner__actions' }>
              <div className={ 'top-banner__actions-top' }>
                { children }
              </div>

              {
                sortOptions &&
                <div className={ `top-banner__actions-bottom ${ hideBottomActions ? 'hidden' : '' }` }>
                  <Sort options={ sortOptions } variant={ 'transparent-white' }/>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

TopBanner.propTypes = {
  title: PropTypes.string,
  intro: PropTypes.string,
  image: PropTypes.string.isRequired,
  sortOptions: PropTypes.array,
  hideBottomActions: PropTypes.bool,
  hasRoundedCorners: PropTypes.bool,
}

export default TopBanner;
